import { Input, Select, DatePicker } from "antd";
import moment from "moment";
import React from "react";
import dayjs from "dayjs";
import Button from "../../NewComponent/Button/Button";
import { toast } from "react-toastify";
import { createIncidentAPI } from "../../API/api";
export default function CreateIncident() {
  const [dateStr, setDateStr] = React.useState(
    moment().format("YYYY-MM-DD HH:mm:ss")
  );
  const [formData, setFormData] = React.useState({
    title: "",
    incidentType: [],
    note: "",
    service: [],
    severity: [],
  });

  const createIncidentForm = () => {
    if (
      !formData.title ||
      Array.isArray(formData.incidentType) ||
      !formData.note ||
      Array.isArray(formData.service) ||
      Array.isArray(formData.severity)
    ) {
      toast.error("Please fill all the fields", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    let formDataCopy = { ...formData };
    formDataCopy.reportedTime = new Date(dateStr).getTime();
    formDataCopy.status = "open";
    formDataCopy.assignee = "devops@digitalmain.com";
    formDataCopy["services"] = [formDataCopy.service];
    delete formDataCopy.service;
    formDataCopy["type"] = formDataCopy.incidentType;
    delete formDataCopy.incidentType;
    formDataCopy.url = "";

    createIncidentAPI(formDataCopy).then((res) => {
      setFormData({
        title: "",
        incidentType: [],
        note: "",
        service: [],
        severity: [],
      });
      setDateStr(moment().format("YYYY-MM-DD HH:mm:ss"));
    });
  };
  const incidentCategories = [
    { label: "Login/SSO", value: "Login_sso" },
    { label: "Notifications", value: "Notifications" },
    { label: "Scheduler", value: "Scheduler" },
    { label: "Routing", value: "Routing" },
    {
      label: "Attachment Preview/Download",
      value: "Attachment Preview/Download",
    },
    { label: "Search", value: "Search" },
    { label: "Apps/Integrations/APIs", value: "Apps/Integrations/APIs" },
    { label: "Administration", value: "administration" },
  ];
  const onChange = (_, dateStr) => {
    setDateStr(moment(dateStr).format());
  };
  return (
    <>
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "50%",
            padding: "20px",
            textAlign: "center",
          }}
        >
          <div>
            <div
              style={{
                float: "left",
                color: "#5c667b",
                fontSize: "16px",
                marginBottom: "5px",
              }}
            >
              Title *
            </div>
            <div>
              <Input.TextArea
                autoSize={{
                  minRows: 1,
                  maxRows: 1,
                }}
                value={formData.title}
                onChange={(e) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    title: e.target.value,
                  }))
                }
                name="title"
                placeholder="Title..."
                size="large"
                span={24}
                style={{ borderColor: "#E0E2E6" }}
              />
            </div>
          </div>
          <br />
          <div
            style={{
              textAlign: "left",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                float: "left",
                color: "#5c667b",
                fontSize: "16px",
                marginBottom: "5px",
                display: "block",
              }}
            >
              Incident type *
            </div>
            <div>
              <Select
                placeholder="Select incident type"
                style={{ width: "100%" }}
                value={formData.incidentType}
                size={"large"}
                onChange={(e) =>
                  setFormData((prevData) => ({ ...prevData, incidentType: e }))
                }
                name="incidentType"
                options={[
                  { label: "Incident", value: "Incident" },
                  { label: "Maintenance", value: "Maintenance" },
                  { label: "Notice", value: "Notice" },
                  { label: "Outage", value: "Outage" },
                ]}
              />
            </div>
          </div>
          <br />
          <div>
            <div
              style={{
                float: "left",
                color: "#5c667b",
                fontSize: "16px",
                marginBottom: "5px",
              }}
            >
              Note *
            </div>
            <div>
              <Input.TextArea
                autoSize={{
                  minRows: 1,
                  maxRows: 3,
                }}
                value={formData.note}
                onChange={(e) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    note: e.target.value,
                  }))
                }
                name="note"
                placeholder="Note..."
                size="large"
                span={24}
                style={{ borderColor: "#E0E2E6" }}
              />
            </div>
          </div>
        </div>
        <div
          style={{
            width: "50%",
            padding: "20px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              textAlign: "left",
              display: "flex",
              flexDirection: "column",
              marginBottom: "1px",
            }}
          >
            <div
              style={{
                float: "left",
                color: "#5c667b",
                fontSize: "16px",
                marginBottom: "5px",
              }}
            >
              Customer Reported Time *
            </div>
            <div>
              <DatePicker
                onChange={onChange}
                value={dayjs(dateStr)}
                showTime
                allowClear={false}
                format="YYYY-MM-DD HH:mm"
                size="large"
                showSecond={false}
                style={{ borderColor: "#E0E2E6", color: "#5c667b" }}
              />
            </div>
          </div>
          <br />
          <div
            style={{
              textAlign: "left",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                float: "left",
                color: "#5c667b",
                fontSize: "16px",
                marginBottom: "5px",
                display: "block",
              }}
            >
              Service *
            </div>
            <div>
              <Select
                placeholder="Select service "
                style={{ width: "100%" }}
                value={formData.service}
                onChange={(e) =>
                  setFormData((prevData) => ({ ...prevData, service: e }))
                }
                name="service"
                size={"large"}
                options={incidentCategories}
              />
            </div>
          </div>
          <br />
          <div
            style={{
              textAlign: "left",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                float: "left",
                color: "#5c667b",
                fontSize: "16px",
                marginBottom: "5px",
                display: "block",
              }}
            >
              Severity *
            </div>
            <div>
              <Select
                placeholder="Select severity"
                style={{ width: "100%" }}
                value={formData.severity}
                onChange={(e) =>
                  setFormData((prevData) => ({ ...prevData, severity: e }))
                }
                name="severity"
                size={"large"}
                options={[
                  { label: "High", value: "High" },
                  { label: "Medium", value: "Medium" },
                  { label: "Low", value: "Low" },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Button type={"primary"} text={"Create"} onClickFunc={createIncidentForm} />
      </div>
    </>
  );
}
